import React from "react";

function NavItem(props) {
  const Icon = props.icon;
  return (
    <div
      onClick={props.onClick}
      index={props.index}
      className={`text-sm h-full w-full p-2 rounded-xl my-2 flex items-center cursor-pointer transition-all hover:scale-105 ${
        props.active
          ? "bg-white text-primary shadow-lg font-bold"
          : "text-white opacity-80 font-semibold"
      }`}
    >
      <span className="px-3">{Icon}</span>
      <span>{props.name}</span>
    </div>
  );
}

export default NavItem;
